import dashboardModule from '../dashboard/index';

export default dashboardModule;
